import { _axios } from '@/plugins/axios'
import userConverter from '@/plugins/converters/user'
import i18n from '@/plugins/i18n'

const state = {
  /**
   * @typedef {Object} UserAir
   * @property {Number} id - ID de l'utilisateur connecté
   * @property {String} firstName - Prénom de l'utilisateur
   * @property {String} lastName - Nom de l'utilisateur
   * @property {String} fullName - Nom complet de l'utilisateur
   * @property {String} username - Pseudo de l'utilisateur
   * @property {Boolean} isAdmin - Indique si l'utilisateur est administrateur
   * @property {Boolean} isStaff - Indique si l'utilisateur est gestionnaire ou simple utilisateur
   *                               donnée stockée dans la base de données
   * @property {Boolean} staffStatus - Indique l'état du status de l'utilisateur pour permettre à
   *                                   un gestionnaire de voir l'application comme un simple user
   * @property {Boolean} lastLogin - Date de la dernière connexion
   *
   * @type {UserAir}
   */
  user: {}
}

const getters = {
  user: state => state.user
}

const actions = {
  loadUser: ({ commit, dispatch, state }) => {
    if (Object.entries(state.user).length === 0) {
      return _axios.get('/user/')
        .then(response => {
          commit('LOAD', response.data)
        })
        .catch(error => {
          dispatch('displayError', { action: i18n.t('store.user.unknown'), error }, { root: true })
        })
    }
  },
  toggleUserStatus: ({ commit }) => {
    commit('TOGGLE_STATUS')
  }
}

const mutations = {
  LOAD: (state, user) => {
    state.user = userConverter.DJToJS.convertUser(user)
  },
  TOGGLE_STATUS: (state) => {
    state.user.staffStatus = !state.user.staffStatus
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
